<template>
    <div>
        <slot
            name="tabs"
            :tabe="tabs"
        >
            <ul>
                <li
                    v-for="(label, value) in tabs"
                    :key="value"
                    class="inline-block"
                >
                    <slot
                        name="tab"
                        :label="label"
                        :value="value"
                        :selected="selected"
                        :select="select"
                    >
                        <button
                            type="button"
                            @click.prevent="select(value)"
                        >
                            {{ label }}
                        </button>
                    </slot>
                </li>
            </ul>
        </slot>

        <slot :selected="selected" />
    </div>
</template>

<script>
    import _ from 'lodash'

    export default {
        props: {
            tabs: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                selected: _.keys(this.tabs)[0]
            }
        },
        methods: {
            select (value) {
                this.selected = value
            }
        }
    }
</script>
